@if (showAsDialog) {
    <div class="modal-header">
        <h2 class="modal-title">Double Check</h2>
    </div>
}

@if (!!message) {
    <div class="modal-body p-0 flex-fill d-flex flex-column compact-form">
        <div class="page-content">
            @if (!showAsDialog) {
                <div class="dx-toolbar mb-3">
                    <button (click)="close()" class="btn btn-primary" [hidden]="hasChanges">Close</button>
                    <button (click)="copy()" class="btn btn-success ms-2" [hidden]="hasChanges">Copy</button>
                    <button (click)="save()" class="btn btn-success" [hidden]="!hasChanges || (mode !== 'drafts' && !isMessagesAdmin)">Save</button>
                    <button (click)="cancel()" class="btn btn-default" [hidden]="!hasChanges">Cancel</button>
                    <!-- <button (click)="send()" class="btn btn-default ms-4" [hidden]="hasChanges || mode != 'drafts' || !canSendOld">Send</button> -->
                    <button (click)="send('sendgrid')" class="btn btn-danger ms-4" [hidden]="hasChanges || mode != 'drafts'">Send via SendGrid</button>
                </div>
            }
            @if (showAsDialog) {
                <div class="dx-toolbar mb-3">
                    <button (click)="send('sendgrid')" class="btn btn-primary me-4">Send</button>
                    <button (click)="closeDialog(true)" class="btn btn-secondary">Cancel</button>
                </div>
            }
            @if (!!message) {
                <div>
                    <dx-form [(formData)]="message" [showColonAfterLabel]="false" [readOnly]="mode != 'drafts'">
                        <dxi-item itemType="group">
                            @if (appInfo.graafschap) {
                                <dxi-item
                                    dataField="from"
                                    [label]="{ text: 'From' }"
                                    editorType="dxSelectBox"
                                    [editorOptions]="{ dataSource: fromOptions, width: '350px', onValueChanged: onFromSelectionChanged }"
                                ></dxi-item>
                            }
                            <dxi-item
                                dataField="toGroupId"
                                [label]="{ text: 'To' }"
                                editorType="dxSelectBox"
                                [editorOptions]="{ dataSource: groups, displayExpr: 'name', valueExpr: 'id', width: '350px' }"
                            ></dxi-item>
                            <dxi-item dataField="subject"></dxi-item>
                            <dxi-item dataField="body">
                                <div *dxTemplate>
                                    <div class="d-flex">
                                        <dx-html-editor
                                            #editor
                                            class="ark-html-editor"
                                            valueType="'html'"
                                            [height]="'500px'"
                                            [(value)]="message.body"
                                            [readOnly]="!isMessagesAdmin && this.mode !== 'drafts'"
                                        >
                                            <!-- this is for angular 17 -->
                                            <dxo-toolbar>
                                                <dxi-item name="undo"></dxi-item>
                                                <dxi-item name="redo"></dxi-item>
                                                <dxi-item name="separator"></dxi-item>
                                                <dxi-item name="header" [acceptedValues]="[1, 2, 3, false]" [options]="{ width: 200 }"></dxi-item>
                                                <dxi-item
                                                    name="size"
                                                    [acceptedValues]="['8pt', '10pt', '11pt', '12pt', '14pt', '18pt', '24pt', '36pt', '72pt']"
                                                    [options]="{
                                                        inputAttr: { 'aria-label': 'Font size' },
                                                    }"
                                                ></dxi-item>
                                                <dxi-item
                                                    name="font"
                                                    [acceptedValues]="[
                                                        'Arial',
                                                        'Calibri',
                                                        'Courier New',
                                                        'Georgia',
                                                        'Impact',
                                                        'Lucida Console',
                                                        'Tahoma',
                                                        'Times New Roman',
                                                        'Verdana',
                                                    ]"
                                                    [options]="{
                                                        inputAttr: { 'aria-label': 'Font family' },
                                                    }"
                                                ></dxi-item>
                                                <dxi-item name="separator"></dxi-item>
                                                <dxi-item name="color"></dxi-item>
                                                <dxi-item name="background"></dxi-item>
                                                <dxi-item name="separator"></dxi-item>
                                                <dxi-item name="bold"></dxi-item>
                                                <dxi-item name="italic"></dxi-item>
                                                <dxi-item name="strike"></dxi-item>
                                                <dxi-item name="underline"></dxi-item>
                                                <dxi-item name="superscript"></dxi-item>
                                                <dxi-item name="subscript"></dxi-item>
                                                <dxi-item name="separator"></dxi-item>
                                                <dxi-item name="alignLeft"></dxi-item>
                                                <dxi-item name="alignCenter"></dxi-item>
                                                <dxi-item name="alignRight"></dxi-item>
                                                <dxi-item name="alignJustify"></dxi-item>
                                                <dxi-item name="increaseIndent"></dxi-item>
                                                <dxi-item name="decreaseIndent"></dxi-item>
                                                <dxi-item name="separator"></dxi-item>
                                                <dxi-item name="insertTable"></dxi-item>
                                                <dxi-item name="deleteTable"></dxi-item>
                                                <dxi-item name="insertRowAbove"></dxi-item>
                                                <dxi-item name="insertRowBelow"></dxi-item>
                                                <dxi-item name="deleteRow"></dxi-item>
                                                <dxi-item name="insertColumnLeft"></dxi-item>
                                                <dxi-item name="insertColumnRight"></dxi-item>
                                                <dxi-item name="deleteColumn"></dxi-item>
                                                <dxi-item name="cellProperties"></dxi-item>
                                                <dxi-item name="tableProperties"></dxi-item>
                                            </dxo-toolbar>
                                            <dxo-table-context-menu [enabled]="true"> </dxo-table-context-menu>
                                            <dxo-media-resizing [enabled]="true"> </dxo-media-resizing>
                                        </dx-html-editor>
                                    </div>
                                </div>
                            </dxi-item>
                            <dxi-item itemType="group" colCount="2">
                                <dxi-item [label]="{ text: 'Attachments' }" class="item-label-left-top">
                                    <div *dxTemplate>
                                        <dx-data-grid
                                            [dataSource]="message.attachments"
                                            keyExpr="id"
                                            [hoverStateEnabled]="false"
                                            [rowAlternationEnabled]="true"
                                            [showRowLines]="true"
                                            [focusedRowEnabled]="false"
                                            class="no-headers"
                                        >
                                            <dxi-column dataField="name" caption="File Name" cellTemplate="linkTemplate"></dxi-column>
                                            <div *dxTemplate="let cell of 'linkTemplate'">
                                                @if (appInfo.neland) {
                                                    <a [attr.href]="cell.data.url" target="_blank">{{ cell.value || "(blank)" }}</a>
                                                }
                                                @if (appInfo.graafschap) {
                                                    <a [attr.href]="cell.data.urlGraafschap" target="_blank">{{ cell.value || "(blank)" }}</a>
                                                }
                                            </div>
                                            @if (mode == "drafts") {
                                                <dxi-column dataField="id" caption="" cellTemplate="commandTemplate" width="60"></dxi-column>
                                            }
                                            <div *dxTemplate="let cell of 'commandTemplate'">
                                                <a (click)="deleteAttachment(cell.data)">Delete</a>
                                            </div>
                                        </dx-data-grid>
                                    </div>
                                </dxi-item>
                                @if (mode == "drafts") {
                                    <dxi-item>
                                        <div *dxTemplate>
                                            <div id="fileuploader-container" style="border: 0.5px dashed darkgray">
                                                <dx-file-uploader
                                                    selectButtonText="Select attachments"
                                                    [multiple]="true"
                                                    xlabelText=""
                                                    accept="*"
                                                    uploadMode="{{ appInfo.graafschap ? 'instantly' : 'useButtons' }}"
                                                    (onUploadStarted)="uploadStarted()"
                                                    (onUploaded)="attachmentUploaded()"
                                                    [uploadUrl]="serviceName + '/api/utility/uploadAttachment/' + message.id"
                                                    [uploadHeaders]="uploadHeaders"
                                                >
                                                </dx-file-uploader>
                                            </div>
                                        </div>
                                    </dxi-item>
                                }
                            </dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            }
        </div>
    </div>
}
@if (showAsDialog) {
    <div class="modal-footer"></div>
}
